(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kh-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kh-cart-count')) {
    class KhCartCount extends HTMLElement {
      connectedCallback() {
        this.refresh = this.refresh.bind(this);
        document.addEventListener('cart:update', this.refresh);
        window.addEventListener('pageshow', this.refresh);
      }
      disconnectedCallback() {
        document.removeEventListener('cart:update', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
        this.controller?.abort();
      }
      async refresh() {
        this.controller?.abort();
        this.controller = new AbortController();
        try {
          const response = await fetch(`${this.dataset.cartUrl}.js`, { cache: 'no-store', signal: this.controller.signal });
          if (!response.ok) return;
          const cart = await response.json();
          const count = this.querySelector('span');
          if (count && Number.isInteger(cart.item_count)) count.textContent = String(cart.item_count);
        } catch (error) {
          if (error.name !== 'AbortError') this.dataset.refreshFailed = 'true';
        }
      }
    }
    customElements.define('kh-cart-count', KhCartCount);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
